"use client";
import React, { useEffect, useState } from "react";

//=== Packages == //
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Button from "@mui/material/Button";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import LocalOfferRoundedIcon from "@mui/icons-material/LocalOfferRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import Image from "next/image";

//=== Images == //
import product from "../media/Session-img.png";

//=== Components == //
import CheckBox from "../compononents/CheckBox/CheckBox";
import Buttons from "../compononents/Button/Button";
import { CURRENCY_SIGNS, numberFormatter } from "../../../hooks/HelperFunctions";
import { useShoppingCart } from "../../../contexts/CartContext";
import { useSelector } from "react-redux";

export default function OrderSummary(props) {
  const {
    courses,
    cartItems,
    paymentData,
    totalPriceToShow,
    setOpenPaymentDrawer,
  } = props;

  const activeCurrency = useSelector(
    (state) => state.currency.activeCurrency
  );

  const [show, setShow] = React.useState();
  const [shoppingData, setShoppingData] = useState([]);
  const { setCartItems, cartItemsCoupons } = useShoppingCart();
  
  let calculatePrice = (item) => {
    let courseWithCoupons = cartItemsCoupons?.find(singleCourse => singleCourse?.courseId == item?.courseId)

    let itemPriceTemp = parseFloat(item?.price);
  
    courseWithCoupons?.couponIds?.forEach((couponId) => {
      let itemPriceTemp2 = parseFloat(item?.price);
      let couponInfo = cartItems
        ?.find(course => course?.courseId == item?.courseId)
        ?.active_coupons
        ?.find(singleCoupon => singleCoupon?.id == couponId);
  
      if(!couponInfo){
        let triedCoupons = localStorage.getItem("tried_coupons") ? JSON.parse(localStorage.getItem("tried_coupons")) : []
        couponInfo = triedCoupons.find((singleCoupon) => singleCoupon?.id == couponId)
      }
      
      if (couponInfo) {
        const discountType = couponInfo?.discount_type;
        const discountValue = parseFloat(couponInfo?.discount_value);
  
        let discountAmount = 0;
  
        if (discountType === 'fixed') {
          discountAmount = discountValue;
        } else if (discountType === 'percentage') {
          discountAmount = (discountValue / 100) * itemPriceTemp2;
        }
  
        itemPriceTemp -= discountAmount;
        // Prevent negative prices
        if (itemPriceTemp < 0) itemPriceTemp = 0;
      }
    });
  
    return itemPriceTemp.toFixed(2);
  };

  useEffect(() => {
    let coursesArrayNew = [];
    let totalPrice = 0;
    courses?.map((singleCourse) => {
      coursesArrayNew.push({
        img: singleCourse?.courseImage,
        title: singleCourse?.courseTitle,
        price: singleCourse.priceCat !== "Free" ? calculatePrice(singleCourse)  : 0,
      });
      if (
        singleCourse?.price &&
        singleCourse?.price > 0 &&
        singleCourse.priceCat !== "Free"
      ) {
        totalPrice += calculatePrice(singleCourse);
      }
    });
    setShoppingData(coursesArrayNew);
  }, [courses]);

  const editCartClickHandler = () => {
    setOpenPaymentDrawer(false);
  };
  
  const getTheCorrectCurrencySign = () => {
    return CURRENCY_SIGNS[activeCurrency] ?? "$";
  };

  return (
    <div className="PM_OrderSummary">
      <div className="PM_OrderSummaryTitle">Order Summary</div>

      <div className="PM_OrderSummaryResultSecton">
        <span>
          {courses?.length > 1
            ? `${courses?.length} items`
            : `${courses?.length} item`}{" "}
        </span>
        <Button variant="text" onClick={editCartClickHandler}>
          Edit Cart
        </Button>
      </div>

      <div className="PM_OrderSummaryListContainer">
        {shoppingData.map((item, i) => (
          <div className="PM_OrderSummaryListing">
            <div className="PM_OrderSummaryListingLeft">
              <div className="PM_OrderSummaryImg">
                <img src={item.img} />
              </div>
              <div className="PM_OrderSummaryDetails">
                <h1>{item.title}</h1>
              </div>
            </div>

            <div className="PM_OrderSummaryListingRight">
              <div className="PM_OrderSummaryPrice">
                {getTheCorrectCurrencySign()} {numberFormatter(item.price)}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="PM_Divider"></div>

      <div className="OrderSummaryTotalDetails">
        <li>
          <div className="OrderSummaryTotal">Total</div>
          {/* <div className='OrderSummaryTotal'>$1,900.80</div> */}
          <div className="OrderSummaryTotal">
            {getTheCorrectCurrencySign()}
            {totalPriceToShow
              ? numberFormatter(totalPriceToShow)
              : numberFormatter(0)}
          </div>
        </li>
      </div>
    </div>
  );
}
